import { Request } from '~src/httpClient/serverApi/requests/Request';

import { IPreviewResult } from '../types/IPreviewResult';

/**
 * Parameters for the VizPortal `previewExtraction` Web Client method
 * (WebClientContentMobilityAppService.previewExtraction): the concrete items a plan's selection
 * resolves to, one page at a time.
 */
export interface IPreviewExtractionParams {
  planLuid: string;
  pageSize?: number;
  /** Token from the previous page's `nextPageToken`; omit for the first page. */
  pageToken?: string;
  /** Zero-based offset of the first item, for offset-paged grids. Send this or `pageToken`, not both. */
  startIndex?: number;
}

export class PreviewExtractionRequest extends Request<IPreviewExtractionParams, IPreviewResult> {
  constructor(params: IPreviewExtractionParams) {
    super('previewExtraction', params);
  }
}
